






























import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import AddButton from '@/components/Admin/Layout/AddButton.vue';
import ConfirmPopup from '@/components/Admin/Panels/ConfirmPopup.vue';
import UnitGroupingList from '@/components/Admin/Lists/UnitGroupingList.vue';

@Component({
    components: {
        AddButton,
        ConfirmPopup,
        UnitGroupingList,
    },
    computed: {
        ...mapGetters({
            allGroupings: 'Groupings/getAllGroupings',
            confirmPopupVisibility: 'ConfirmPopup/getConfirmPopupVisibility',
        }),
    },
})
export default class Groupings extends Vue {
    public search: any = '';
        public tabs: any[] = [
        {
            id : 0,
            title : 'Unit groupings',
            translations_key : 'unit-groupings',
            status : true,
            requestOption : 'unit',
        },
        // {
        //     id : 1,
        //     title : 'User groupings',
        //     translations_key : 'user-groupings',
        //     status : false,
        //     requestOption : 'user',
        // },
    ];

    constructor() {
        super();
    }

    public addGrouping() {
        this.$router.push({name: 'admin-grouping-add'});
    }

    public isTabActive(id: number) {
        return this.tabs[id].status;
    }

    public toggleGroupingTab(id: any) {
        if (!this.tabs[id].status) {
            this.tabs.forEach( (tab) => tab.status = false );
            this.tabs[id].status = true;
        }
    }
}
